import dayjsTZ from "../../../../utils/dayjs";
import { store } from "../../../../store";
import { groupSingleShift } from "../../../Pagat/PaySub/employeeCalc/calculcate";
import {
  buildReportResult,
  emptyReportResult,
  employeeFullName,
  intervalBounds,
  round2,
} from "../reportResult";

/**
 * Overtime bank: per-employee rollup of evening/night buckets and weekend hours.
 */
export const otBank = (_prev, filter, columns, manualColumns, employees) => {
  if (!filter) return emptyReportResult(columns, manualColumns);

  const data = store?.getState()?.customReducer?.reportClockings || [];
  const { startTs, endTs } = intervalBounds(filter);
  const empById = new Map((employees || []).map((e) => [e.employeeId, e]));

  const agg = new Map();

  for (const d of data) {
    if (!d?.clockInDate || !d?.clockOutDate) continue;
    if (d.clockInDate < startTs || d.clockInDate > endTs) continue;
    if (filter?.employeeId && d.employeeId !== filter.employeeId) continue;

    const emp = d.employeeDetails || empById.get(d.employeeId) || {};
    const id = d.employeeId;
    if (!agg.has(id)) {
      agg.set(id, {
        employee: employeeFullName(emp),
        employeeDepartmentName: emp.employeeDepartmentName || "",
        employeeTeam: emp.employeeTeam || "",
        between19and22: 0,
        after22: 0,
        weekendHours: 0,
        totalOt: 0,
        shiftCount: 0,
      });
    }
    const row = agg.get(id);
    const { EXTRA_HOURS = {}, LATE_HOURS = {} } = groupSingleShift(d) || {};
    const late = Number(LATE_HOURS?.amount) || 0;
    const extra = Number(EXTRA_HOURS?.amount) || 0;
    const duration = dayjsTZ(d.clockOutDate).diff(
      dayjsTZ(d.clockInDate),
      "hours",
      true,
    );
    const dow = dayjsTZ(d.clockInDate).day();
    const weekend = dow === 0 || dow === 6 ? duration : 0;

    row.between19and22 += late;
    row.after22 += extra;
    row.weekendHours += weekend;
    row.totalOt += late + extra + weekend;
    row.shiftCount += 1;
  }

  const preFilter = [...agg.values()]
    .map((r) => ({
      ...r,
      between19and22: round2(r.between19and22),
      after22: round2(r.after22),
      weekendHours: round2(r.weekendHours),
      totalOt: round2(r.totalOt),
    }))
    .filter((r) => r.totalOt > 0)
    .sort((a, b) => b.totalOt - a.totalOt);

  return buildReportResult(preFilter, columns, manualColumns);
};
